export default "__VITE_ASSET__B6hMOwY0__"